import lockScroll from './lock-scroll'
import viewport from './viewport';
import {slideToggle} from "./slide-toggle";
import 'particles.js'

export default function () {

    let catalogMenuBtn = document.getElementsByClassName('main-menu__link--catalog');
    let closeMenuBtn = document.getElementsByClassName('catalog-menu-drop__close');
    let menuDrop = document.getElementsByClassName('catalog-menu-drop')[0];


    if (!catalogMenuBtn.length || !closeMenuBtn.length) return;

    Array.from(catalogMenuBtn).forEach(button => button.addEventListener('click', function(e){
        if(viewport().width > 768) {
            document.body.classList.toggle('catalog-menu-opened');
            e.preventDefault();
        }
    }));

    Array.from(closeMenuBtn).forEach(button => button.addEventListener('click', function(e){
        if(viewport().width > 768) {
            document.body.classList.remove('catalog-menu-opened');
            e.preventDefault();
        }
    }));


    document.body.addEventListener("click", function(e) {
        let elm = e.target;
        while (elm !== document.body) {
            if (/(?:^| )catalog-menu-drop(?:$| )/.test(elm.className) || /(?:^| )main-menu__link--catalog(?:$| )/.test(elm.className)) {
                return;
            }
            elm = elm.parentNode;
        }
        document.body.classList.remove('catalog-menu-opened');
    });

    /*menuDrop.addEventListener('mouseenter', function(e){
        if(viewport().width > 768) {
            document.body.classList.add('catalog-menu-opened');
        }
    });

    menuDrop.addEventListener('mouseleave', function(e){
        if(viewport().width > 768) {
            document.body.classList.remove('catalog-menu-opened');
        }
    });

    Array.from(catalogMenuBtn).forEach(button => button.addEventListener('mouseleave', function(e){
        if(viewport().width > 768) {
            document.body.classList.remove('catalog-menu-opened');
        }
    }));
    */

    let adaptiveBurger = document.getElementsByClassName('header-burger')[0];

    adaptiveBurger.addEventListener('click', function () {
        if(document.body.classList.contains('menu-opened')){
            lockScroll(0);
            document.body.classList.remove('menu-opened');
            document.body.classList.remove('catalog-menu-opened-lvl2');
        }
        else{
            lockScroll(1);
            document.body.classList.add('menu-opened');
        }
    });


    let categoryBtn = document.getElementsByClassName('js-mobile-category');

    let categoryLvl2Items = Array.from(document.getElementsByClassName('adaptive-categories__item'));

    Array.from(categoryBtn).forEach(button => button.addEventListener('click', function(e){
        if(viewport().width < 768) {
            document.body.classList.add('catalog-menu-opened-lvl2');

            let currentId = Array.prototype.indexOf.call(categoryBtn, this);

            categoryLvl2Items.forEach(function (item) {
                item.classList.remove('is-active');
            });

            categoryLvl2Items[currentId].classList.add('is-active');

            e.preventDefault();
        }

    }));


    let categoryCloseBtn = document.getElementsByClassName('adaptive-categories-close')[0];

    categoryCloseBtn.addEventListener('click', function () {
        document.body.classList.remove('catalog-menu-opened-lvl2');
    });


    let footerTitleBtn = document.getElementsByClassName('page-footer__title');

    Array.from(footerTitleBtn).forEach(button => button.addEventListener('click', function(e){
        let currentBtn = this;
        if(viewport().width < 576) {
            slideToggle(this.nextElementSibling, 500, function () {
                currentBtn.classList.toggle('is-opened');
            });
        }
    }));


    let closeCity = document.getElementsByClassName('js-close-city');

    Array.from(closeCity).forEach(button => button.addEventListener('click', function(e){
        let cityLink = document.getElementsByClassName('page-header__location')[0];

        cityLink.classList.remove('show-drop');
    }));


    let particles = document.getElementsByClassName('particles');

    if(particles.length > 0) {
        let particlesUrl = particles[0].getAttribute('data-url');

        Array.from(particles).forEach(function (item) {

            let currentId = item.getAttribute('id');

            particlesJS.load(currentId, particlesUrl, function () {
            });
        });
    }

}
